import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Sentry frontend initialization
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.3,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE || "production",
  });
}

if (!window.location.hash) {
  window.location.hash = "#/";
}

const root = createRoot(document.getElementById("root")!);

if (SENTRY_DSN) {
  root.render(
    <Sentry.ErrorBoundary fallback={<div className="p-8 text-center text-muted-foreground">Произошла ошибка. Попробуйте обновить страницу.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  );
} else {
  root.render(<App />);
}
